import { SessionInfo } from './types';

export class ConversationManager {
  private sessionId: string | null = null;
  private previousResponseId: string | null = null;

  /**
   * Get current session information
   */
  getSessionInfo(): SessionInfo {
    return {
      sessionId: this.sessionId,
      previousResponseId: this.previousResponseId,
    };
  }

  /**
   * Update session information
   */
  updateSession(sessionId: string, responseId: string): void {
    this.sessionId = sessionId;
    this.previousResponseId = responseId;
  }

  /**
   * Clear session information
   */
  clear(): void {
    this.sessionId = null;
    this.previousResponseId = null;
  }

  /**
   * Check if session is active
   */
  hasActiveSession(): boolean {
    return this.sessionId !== null;
  }

  /**
   * Get session ID
   */
  getSessionId(): string | null {
    return this.sessionId;
  }

  /**
   * Get previous response ID
   */
  getPreviousResponseId(): string | null {
    return this.previousResponseId;
  }
} 